import React, { useState } from 'react'
import { useTranslation } from 'language/translator'

import { TWidgetSettings, WidgetType } from 'types/GlobalWidget'
import { KpiOptionObject } from 'types/GlobalKpiOption'

import Switch from 'components_new/atoms/Switch'

import SettingsEditDialog from 'components_new/molecules/SettingsEditDialog'
import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'
import { TPatchKpiOptionBody } from 'redux/api/KpiOptions'

interface TitleSectionProps {
  kpi: KpiOptionObject
  updateKpiOption: (body: TPatchKpiOptionBody) => void
  settings: TWidgetSettings
}

const TitleSection = (props: TitleSectionProps) => {
  const { kpi, settings, updateKpiOption } = props
  const { t } = useTranslation()

  /*-- toggle --*/
  const handleToggle = () => {
    updateKpiOption({
      hidden: !kpi.hidden
    })
  }

  /*-- dialog --*/
  const [dialog, setDialog] = useState<{
    open: boolean
    title: string
    data: {
      value: string
    }
  }>({
    open: false,
    title: '',
    data: { value: '' }
  })

  const handleOpenDialog = () => {
    setDialog({
      open: true,
      title: t('global', 'name'),
      data: { value: kpi.title }
    })
  }

  const handleCloseDialog = () => {
    setDialog((prevState) => ({ ...prevState, open: false }))
  }

  const handleEditDialogValue = (value: string) => {
    setDialog((prevState) => ({
      ...prevState,
      data: { ...prevState.data, value }
    }))
  }

  const handleSubmitDialog = () => {
    updateKpiOption({
      title: dialog.data.value
    })
    handleCloseDialog()
  }

  return (
    <>
      <SettingsGroup>
        {[WidgetType.LIST].includes(settings.type.selected) ? (
          <SettingsItem
            actions={
              <Switch
                checked={!kpi.hidden}
                onChange={() => handleToggle()}
                size="small"
              />
            }
            title={t('global', 'show')}
          />
        ) : null}
        <SettingsItem
          onClick={() => handleOpenDialog()}
          title={t('global', 'name')}
          value={kpi.title}
          variant="edit"
        />
      </SettingsGroup>

      {/*-- dialogs --*/}
      <SettingsEditDialog
        disabled={
          // if title is duplicate
          settings.kpi_options.some(
            (option) =>
              option.id !== kpi.id && option.title === dialog.data.value
          )
        }
        onChange={handleEditDialogValue}
        onClose={handleCloseDialog}
        onSubmit={handleSubmitDialog}
        open={dialog.open}
        title={dialog.title}
        type={'text'}
        value={dialog.data.value}
      />
    </>
  )
}

export default TitleSection
